export default __webpack_public_path__ + "static/media/p8.6221a949.jpeg";